import { render, staticRenderFns } from "./LLAvatarCropperWrapper.vue?vue&type=template&id=454245ba&scoped=true"
import script from "./LLAvatarCropperWrapper.vue?vue&type=script&lang=js"
export * from "./LLAvatarCropperWrapper.vue?vue&type=script&lang=js"
import style0 from "./LLAvatarCropperWrapper.vue?vue&type=style&index=0&id=454245ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454245ba",
  null
  
)

export default component.exports